module.exports = {
	"sitedownloads": "https://storage.googleapis.com/interactive-austinlara/data/live/sitedownloads",
	"sitedownloadsfiltered": "https://storage.googleapis.com/interactive-austinlara/data/live/sitedownloadsfiltered",
	"masterplan": "https://storage.googleapis.com/interactive-austinlara/data/live/masterplan",
	"stageplan": "https://storage.googleapis.com/interactive-austinlara/data/live/stageplan",
	"lotplan": "https://storage.googleapis.com/interactive-austinlara/data/live/lotplan",
	"searchfields": "https://storage.googleapis.com/interactive-austinlara/data/live/searchfields",
	"packagesearch": "https://storage.googleapis.com/interactive-austinlara/data/live/packagesearch",
	"package": "https://storage.googleapis.com/interactive-austinlara/data/live/package",
	"location": "https://interactive-sundar.appspot.com/location",
	"spacerimage": "https://storage.googleapis.com/interactive-austinlara/assets/images/spacer.png",
	"googlemapsapikey": "AIzaSyAbPvjIEFgSzyoEaAi3at10xAp8S17uEq0",
	"activestatus": [
		1,
		3
	],
	"landforsalepath": "/land-for-sale",
	"houseandlandpath": "/house-land",
	"landlink": "/land-for-sale",
	"designguidelinesfile": "https://storage.googleapis.com/interactive-austinlara/test/pdfs/Bowery-DesignGuidelines.pdf"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/config.json
 ** module id = 248
 ** module chunks = 0
 **/